import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M6.25 3.906a.47.47 0 0 0-.469.469v11.25c0 .258.211.469.469.469h2.344v-1.875a1.407 1.407 0 0 1 2.812 0v1.875h2.344a.47.47 0 0 0 .469-.469V4.375a.47.47 0 0 0-.469-.469zm-1.875.469c0-1.034.84-1.875 1.875-1.875h7.5c1.034 0 1.875.84 1.875 1.875v11.25c0 1.034-.84 1.875-1.875 1.875h-7.5a1.877 1.877 0 0 1-1.875-1.875zm2.578 1.172a.47.47 0 0 1 .469-.469h1.406a.47.47 0 0 1 .469.469v1.406a.47.47 0 0 1-.469.469H7.422a.47.47 0 0 1-.469-.469zm4.219-.469h1.406a.47.47 0 0 1 .469.469v1.406a.47.47 0 0 1-.469.469h-1.406a.47.47 0 0 1-.469-.469V5.547a.47.47 0 0 1 .469-.469M6.953 9.297a.47.47 0 0 1 .469-.469h1.406a.47.47 0 0 1 .469.469v1.406a.47.47 0 0 1-.469.469H7.422a.47.47 0 0 1-.469-.469zm4.219-.469h1.406a.47.47 0 0 1 .469.469v1.406a.47.47 0 0 1-.469.469h-1.406a.47.47 0 0 1-.469-.469V9.297a.47.47 0 0 1 .469-.469"
    }, null, -1)
  ]))]))
}
export default { render: render }